import RestartIcon from 'assets/restart_button_img.svg?react';
import styled from 'styled-components';


const RestartButton = (props) => {
  const { sending, handleRestartClick } = props;
  return (
    <Root
      data-tooltip-id={sending ? 'gray-button-tooltip' : ''}
      onClick={handleRestartClick}
      disabled={sending}
    >
      <RestartIcon />
    </Root>
  );
};

export default RestartButton;

const Root = styled.div`
  cursor: pointer;
  border-radius: 50%;
  min-width: 40px;
  width: 40px;
  height: 40px;
  background-color: #100D0B;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${props => (props.disabled ? 0.5 : 1)};

  @media (min-width: 720px) {
    z-index: 50;
    position: relative;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;